import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import BaseComponent from "../../BaseComponent.js";
import NanoFlex from "../../Global/NanoFlex.js";
import Type from "../../Global/Typography.js";
import SimpleButton from "../../Buttons/SimpleButton.js";

//IMGS
import { ReactComponent as CubeIcon } from "../../Global/icons/cube.svg";
import { ReactComponent as AirplaneIcon } from "../../Global/icons/Airplane.svg";

const StyledCertificationBlock = styled(NanoFlex)`
  border-radius: 10px;
  padding: 0 100px;

  .colorBackground {
    border-radius: 10px;
    background-color: ${(props) => props.theme.color.primaryColors.lighterPurple};
    padding: 32px;

    .certificationContent {
      gap: 24px;

      .certificationTitle {
        gap: 24px;

        h3 {
          color: ${(props) => props.theme.color.primaryColors.darkPurple};
          font-weight: 500;
        }
      }
    }

    .knowMoreButtonWrapper {
    }
  }

  @media only screen and (max-width: 1450px) {
    padding: 0 50px;
    .colorBackground {
      padding: 32px 50px 32px 50px;
    }
  }

  @media only screen and (max-width: 1024px) {
    padding: 0 30px;

    .colorBackground {
      padding: 32px;

      .certificationContent {
        padding-right: 50px;

        .certificationTitle {
          gap: 16px;
        }
      }

      .knowMoreButtonWrapper {
        width: fit-content;

        button {
          white-space: nowrap;
        }
      }
    }
  }

  @media only screen and (max-width: 815px) {
    padding: 0 10px;

    .colorBackground {
      padding: 16px;
      border-radius: 5px;
      flex-direction: column;
      gap: 16px;

      .certificationContent {
        .iconWrapper {
          svg {
            height: 53px;
            width: auto;
          }
        }
      }
    }
  }
`;

export default class CertificationBlock extends BaseComponent {
  componentDidMount() {
    super.componentDidMount();
  }

  componentWillUnmount() {
    super.componentWillUnmount();
  }

  render() {
    return (
      <StyledCertificationBlock alignItems={"flex-end"}>
        <NanoFlex className="colorBackground" alignItems="flex-end">
          <NanoFlex className="certificationContent" flexDirection="column">
            <NanoFlex className="iconWrapper" justifyContent="flex-start">
              <AirplaneIcon />
            </NanoFlex>
            <NanoFlex className="certificationTitle" flexDirection="column" alignItems="flex-start">
              <Type.p>{this.translation.assessment.thomasCertification}</Type.p>
              <Type.h3>{this.translation.assessment.didYouKnow}</Type.h3>
            </NanoFlex>
          </NanoFlex>
          <NanoFlex className="knowMoreButtonWrapper" justifyContent="flex-end" alignItems="flex-end">
            <Link to="#contacts">
              <SimpleButton darkPurple label={this.translation.homepage.forCompanies.knowMore} />
            </Link>
          </NanoFlex>
        </NanoFlex>
      </StyledCertificationBlock>
    );
  }
}
